import React, { useState } from "react";
import { IconButton, Modal, Box, Paper } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import ChatOikos from ".";

const ChatOikosButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={() => setOpen((prev) => !prev)} // Toggle: abre/fecha
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 2000,
          backgroundColor: "#1976d2",
          color: "#fff",
          boxShadow: 3,
          "&:hover": {
            backgroundColor: "#1565c0",
          },
        }}
        aria-label="Abrir chat Ecossis"
      >
        <ChatBubbleOutlineIcon />
      </IconButton>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="chat-ecossis-modal"
        aria-describedby="janela-de-chat-da-ia-da-ecossis"
        closeAfterTransition
        // O MUI já fecha ao clicar fora!
      >
        <Box
          sx={{
            position: "fixed",
            bottom: 100,
            right: 24,
            width: 500,
            maxWidth: "95vw",
            height: 600,
            maxHeight: "95vh",
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            display: "flex",
            flexDirection: "column",
            zIndex: 3000,
            overflow: "hidden",
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <strong>IA da Ecossis</strong>
            <IconButton size="small" onClick={() => setOpen(false)} aria-label="Fechar chat">
              <CloseIcon />
            </IconButton>
          </Box>

          <Paper
            elevation={0}
            sx={{
              flex: 1,
              overflow: "auto",
              border: "1px solid #ccc",
              borderRadius: 1,
              background: "#fdfdfd",
              minWidth: 0,
              display: "flex",
              flexDirection: "column"
            }}
          >
            <ChatOikos />
          </Paper>
        </Box>
      </Modal>
    </>
  );
};

export default ChatOikosButton;
